import React from 'react';
import { displayManifestBrand } from '../../utils/testRigHelpers/manifestTruth';

/**
 * The lot's ground truth, beside the answers graded against it: the brand and
 * the product its manifest line names. It is lot-level truth — one line for
 * every item of the lot — so the cell spans the lot's rows.
 *
 * Three states. A run whose dataset ships no manifest shows a dash; a lot the
 * manifest cannot arbitrate (several products, nothing specific) says it was
 * not graded; a graded lot prints what it was graded against.
 */
const NOT_GRADED =
  'Not graded: the manifest lists several products, or names nothing specific enough to grade.';

// The scorer keys a brand on its first word, so "Hampton Bay" shows as Hampton —
// and an answer of Hampton Bay, or Hampton, is right.
const BRAND_NOTE =
  'The brand word the answer is graded on. A multi-word brand shows its first word; any answer starting with it counts.';

const ManifestTruthCell = ({ result, run, rowSpan }) => {
  const runWasGraded = Boolean(run && typeof run.identification === 'object' && run.identification);
  const expectedName = typeof result?.expected_name === 'string' ? result.expected_name : '';
  const expectedBrand = typeof result?.expected_brand === 'string' ? result.expected_brand : '';
  const brand = displayManifestBrand(expectedName, expectedBrand);

  let body;
  if (!runWasGraded) {
    body = <span className="text-muted" title="This run's dataset ships no manifest lines.">-</span>;
  } else if (!expectedName) {
    body = <span className="italic text-muted" title={NOT_GRADED}>Not graded</span>;
  } else {
    body = (
      <div className="space-y-0.5">
        <div title={BRAND_NOTE}>
          <span className="font-semibold">Brand:</span>{' '}
          {brand || <span className="italic text-muted">none named</span>}
        </div>
        <div className="break-words">
          <span className="font-semibold">Product:</span> {expectedName}
        </div>
      </div>
    );
  }
  return (
    <td className="px-1.5 py-1 border-r border-hairline align-top" rowSpan={rowSpan}>
      {body}
    </td>
  );
};

export default ManifestTruthCell;
